
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1200 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3f9c35","d":"M0 0h1200v600H0z"}}),_c('path',{attrs:{"fill":"#ed2939","d":"M0 0h1200v400H0z"}}),_c('path',{attrs:{"fill":"#00b9e4","d":"M0 0h1200v200H0z"}}),_c('circle',{attrs:{"cx":"580","cy":"300","r":"90","fill":"#fff"}}),_c('circle',{attrs:{"cx":"600","cy":"300","r":"75","fill":"#ed2939"}}),_c('path',{attrs:{"d":"M680 250l9.567 26.903 25.788-12.258-12.258 25.788L730 300l-26.903 9.567 12.258 25.788-25.788-12.258L680 350l-9.567-26.903-25.788 12.258 12.258-25.788L630 300l26.903-9.567-12.258-25.788 25.788 12.258L680 250z","fill":"#fff"}})])
          )
        }
      }
    